import { ApplicationVersionDto } from '@app/applicationVersions/dto';
import { useTranslations } from '@i18n/use-translations';
import { message } from 'antd';
import { useCallback } from 'react';

export const useDownloadApp = () => {
  const t = useTranslations();

  const downloadApp = useCallback(
    async (version: ApplicationVersionDto) => {
      if (!version) {
        message.error(t('applicationVersions.download.notFound'));
        return;
      }
      const link = document.createElement('a');
      link.href = version.fileUrl;
      link.download = '';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    [t],
  );

  return { downloadApp };
};
